import React, { memo } from 'react';
import HouseGlyph from './HouseGlyph';
import '../styles/LoadingScreen.css';

// Memoize the entire component to prevent re-renders unless message changes
const LoadingScreen = memo(({ message }) => {
  return (
    <div className="app-loading-container">
      <div className="loading-content">
        <HouseGlyph />
        {message && <div className="loading-message">{message}</div>}
      </div>
    </div>
  );
});

LoadingScreen.displayName = 'LoadingScreen';

export default LoadingScreen;
